import { request } from "./http";

export interface AmlAlert {
  id: string;
  user_id: string;
  user_email: string | null;
  user_name: string | null;
  rule_id: string;
  severity: "low" | "medium" | "high" | "critical";
  status: "open" | "reviewing" | "cleared" | "escalated";
  trigger_type: "deposit" | "withdrawal" | "rescan" | string;
  trigger_ref: string | null;
  payload: Record<string, unknown>;
  decision_note: string | null;
  decided_by: string | null;
  decided_at: string | null;
  sar_filed_at: string | null;
  created_at: string;
}

export const aml = {
  list: (params: { status?: AmlAlert["status"]; severity?: AmlAlert["severity"]; limit?: number } = {}) => {
    const qs = new URLSearchParams();
    if (params.status) qs.set("status", params.status);
    if (params.severity) qs.set("severity", params.severity);
    if (params.limit) qs.set("limit", String(params.limit));
    return request<AmlAlert[]>(`/api/v1/admin/aml/alerts${qs.toString() ? "?" + qs : ""}`);
  },
  decide: (id: string, body: { status: AmlAlert["status"]; note?: string }) =>
    request<AmlAlert>(`/api/v1/admin/aml/alerts/${id}/decide`, {
      method: "POST",
      body,
    }),
};
